module.exports = "<p-progressBar *ngIf=\"isShow\" mode=\"indeterminate\" [style]=\"{'height': '6px'}\"></p-progressBar>"